import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import {
    Alert,
    Box,
    Divider,
    Stack,
    Typography,
    useTheme,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { toast } from 'react-toastify';
import { ButtonBasic } from '../../components';
import NotifyBajaDAService from '../../services/notifyBajaDA.service';

const ModalConfirmIniciarProceso = ({ show, hideModal, keyGroup, total, onConfirm }) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [isProcessing, setIsProcessing] = useState(false);

    const handleClose = () => hideModal();

    const onIniciar = async () => {
        setIsProcessing(true);
        try {
            const resp = await NotifyBajaDAService.iniciarProceso(keyGroup);
            const procesados = resp?.data?.total ?? resp?.total ?? total;
            const segundos = procesados * 1;
            toast.info(
                `El proceso fue iniciado en segundo plano. Se generarán ${procesados} ticket${procesados !== 1 ? 's' : ''} y se enviarán los correos a razón de 1 por segundo (~${segundos}s). Podés cerrar esta pantalla.`,
                { autoClose: 8000 }
            );
            if (onConfirm) onConfirm();
            handleClose();
        } catch (err) {
            const msg = err?.response?.data?.msg || 'No se pudo iniciar el proceso.';
            toast.error(msg);
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <Dialog open={show} disableEscapeKeyDown maxWidth='sm' fullWidth>
            <Box sx={{ background: isDarkMode ? '#1F2A40' : '#fff' }}>
                <DialogTitleDefault id='confirm-iniciar-rda' onClose={handleClose}>
                    <Typography sx={{ flex: 1, textAlign: 'center', color: isDarkMode ? '#fff' : '#000', fontWeight: 'bold' }} variant='h5'>
                        Iniciar proceso
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{ background: isDarkMode ? '#3d4a62' : 'gray' }} />
                <DialogContent>
                    <Stack alignItems='center' spacing={2} sx={{ py: 2 }}>
                        <WarningAmberIcon sx={{ fontSize: 64, color: isDarkMode ? '#90caf9' : '#1976d2' }} />
                        <Typography sx={{ textAlign: 'center', color: isDarkMode ? '#fff' : '#111', fontWeight: 'bold', fontSize: 16 }}>
                            ¿Confirmás el inicio del proceso para el grupo{' '}
                            <span style={{ fontFamily: 'monospace', color: isDarkMode ? '#90caf9' : '#1976d2' }}>{keyGroup}</span>?
                        </Typography>
                        <Alert severity='info' sx={{ width: '100%' }}>
                            <Typography sx={{ fontSize: 13 }}>
                                Se generarán los <b>tickets</b> y se enviarán los <b>correos</b> correspondientes a los{' '}
                                <b>{total}</b> registros pendientes.
                            </Typography>
                            <Typography sx={{ fontSize: 13, mt: 1 }}>
                                El proceso enviará <b>1 ticket por segundo</b>.
                            </Typography>
                        </Alert>
                    </Stack>
                </DialogContent>
                <Divider sx={{ background: isDarkMode ? '#3d4a62' : 'gray' }} />
                <DialogActions sx={{ p: 2 }}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='outlined'
                        color='inherit'
                        onClick={handleClose}
                        isDisabled={isProcessing}
                    />
                    <ButtonBasic
                        textButton='Iniciar proceso'
                        color='primary'
                        iconStart={<PlayArrowIcon />}
                        onClick={onIniciar}
                        isLoading={isProcessing}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default ModalConfirmIniciarProceso;
